// extracted by mini-css-extract-plugin
module.exports = {"referralLoginDriver":"_1VJcD","twoPanelsContainer":"_2u9ko","panelReferralDriver":"_2JncL","panelContent":"_1rLuk","twoPanelsContainer--referralDriverHidden":"_28HJg"};